
const grid = 8;

export const getListStyle = (isDraggingOver, listStyle) => ({
  background: listStyle.background,
  padding: grid,
  width: `100%`
});